import { Box } from "@chakra-ui/react";


export default function LaunchdeckSpinner({ boxSize = "2em", thickness = "3px" }) {
  return (
    <Box
      className="launchdeck-spinner"
      sx={{ "--spinner-border-thickness": thickness }}
      boxSize={boxSize}
    />
  );
}
